import { render, staticRenderFns } from "./assessmentlevel.vue?vue&type=template&id=4e062063&scoped=true"
import script from "./assessmentlevel.vue?vue&type=script&lang=js"
export * from "./assessmentlevel.vue?vue&type=script&lang=js"
import style0 from "./assessmentlevel.vue?vue&type=style&index=0&id=4e062063&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e062063",
  null
  
)

export default component.exports